var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TextValue',{attrs:{"value":_vm.display}})
}
var staticRenderFns = []

export { render, staticRenderFns }